// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"173":"7302755e","334":"ccb9dd1e","339":"1f50b04c","515":"08d975d2","534":"71b29fca","870":"6b743d1c"}[chunkId] + ".chunk.js";
};